import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0px;
  margin-left: 10px;
  margin-right: 0;
  overflow: visible;
`;

export const InputWrapper = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  align-items: center;
  min-width: fit-content;
  position: relative;
  z-index: 10;
`;

export const Image = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const FourColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr 1fr 80px;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  width: 100%;
  max-width: 100%;
  overflow: visible;
  box-sizing: border-box;
  position: relative;
`;

export const ColumnTitle = styled.div`
  font-weight: 500;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ColumnInput = styled.div`
  width: 100%;
`;

export const ModalContent = styled.div`
  padding: 20px 0;
`;

export const ButtonGrid = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const Paragraph = styled.p`
  margin: 8px 0 0 0;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
`;
